import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";

const QUICK_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Books", path: "/books" },
  { label: "Insights", path: "/insights" },
  { label: "Speaking", path: "/speaking" },
  { label: "Contact", path: "/contact" },
];

const PILLARS = [
  { label: "Reform Publishing LLC", path: "/books" },
  { label: "Reform Intelligence", path: "/reform-intelligence" },
  { label: "VALOR, Inc.", path: "/valor" },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await api.post("/subscribers", { email, list_type: "general" });
      setStatus("Subscribed!");
      setEmail("");
      setTimeout(() => setStatus(""), 3000);
    } catch {
      setStatus("Error. Try again.");
    }
  };

  return (
    <footer data-testid="main-footer" className="bg-[#1B2A4A] text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          <div>
            <h4 className="font-heading font-bold text-sm tracking-[0.15em] uppercase text-[#C9A84C] mb-6">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-3">
              {QUICK_LINKS.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-white/70 hover:text-[#C9A84C] transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm tracking-[0.15em] uppercase text-[#C9A84C] mb-6">
              The Three Pillars
            </h4>
            <nav className="flex flex-col gap-3">
              {PILLARS.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`footer-pillar-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-white/70 hover:text-[#C9A84C] transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm tracking-[0.15em] uppercase text-[#C9A84C] mb-6">
              Stay Informed
            </h4>
            <p className="text-sm text-white/70 mb-4">
              Get original insights on the Great Wealth Transfer, minority entrepreneurship, and AI governance.
            </p>
            <form onSubmit={handleSubscribe} className="flex gap-2">
              <Input
                type="email"
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="footer-email-input"
                className="bg-white/10 border-white/20 text-white placeholder:text-white/40 rounded-sm flex-1 focus:ring-[#C9A84C]"
              />
              <Button
                type="submit"
                data-testid="footer-subscribe-btn"
                className="bg-[#C9A84C] text-[#1B2A4A] hover:bg-[#b59744] hover:text-white rounded-sm font-semibold"
              >
                Subscribe
              </Button>
            </form>
            {status && <p className="text-xs text-[#C9A84C] mt-2">{status}</p>}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-white/40">
              PhD, CHS-III, CISSP, PMP | Member, MENSA International | U.S. Army Veteran
            </p>
            <p className="text-xs text-white/40">
              &copy; {new Date().getFullYear()} Dr. Ben Magee. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
